<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="Icons/Plus" clip-path="url(#clip0_13549_180111)">
<path id="Icon plus" fill-rule="evenodd" clip-rule="evenodd" d="M8.69715 0H7.3018C7.17777 0 7.11576 0.0592593 7.11576 0.177778V7.15547H0.186047C0.0620155 7.15547 0 7.21473 0 7.33325V8.66658C0 8.7851 0.0620155 8.84436 0.186047 8.84436H7.11576V15.8222C7.11576 15.9407 7.17777 16 7.3018 16H8.69715C8.82118 16 8.8832 15.9407 8.8832 15.8222V8.84436H15.814C15.938 8.84436 16 8.7851 16 8.66658V7.33325C16 7.21473 15.938 7.15547 15.814 7.15547H8.8832V0.177778C8.8832 0.0592593 8.82118 0 8.69715 0Z" fill="white"/>
</g>
<defs>
<clipPath id="clip0_13549_180111">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>
